import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { ArcButton } from '../../common/components/ArcButton';
import { selectSite } from '../site/siteSlice';

export const ConfigureDeviceButton = () => {
  const navigate = useNavigate();
  const { site_id: siteId } = useSelector(selectSite);
  const { t } = useTranslation();

  return (
    <ArcButton
      data-testid={'notification-configure-device'}
      arcColor="#3DCD58"
      w={'90%'}
      mx="auto"
      mt={6}
      minW={300}
      onClick={() => navigate(`/sites/${siteId}/devices/list`)}
    >
      {t('Devices.configure device')}
    </ArcButton>
  );
};
